import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useFilterStyles = makeStyles({
  container: {
    maxWidth: '300px',
    width: '50%',
    display: 'flex',
    flexGrow: '1',
    justifyContent: 'flex-end',
  },
  button: {
    paddingTop: 0,
    paddingLeft: '5px',
    paddingRight: '0px',
    paddingBottom: '0px',
    width: 'fit-content',
  },
  buttonText: {
    ...shorthands.overflow('hidden'),
    lineBreak: 'anywhere',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: tokens.colorNeutralForeground2,
  },
  listbox: {
    maxHeight: '300px',
    minWidth: '250px',
  },
  dropdown: {
    ...shorthands.border('none'),
    minWidth: '100px',
  },
});
